<template>
  <div class="routelist">
    <h2 v-if="language == 'de'">Aktuelle Routen</h2>
    <h2 v-if="language == 'pl'">Aktualne trasy</h2>
    <h2 v-if="language == 'cz'">Aktuální trasy</h2>

    <ul class="routes">
      <li v-for="route in routen">
        <router-link :to="{ name: 'route', params: { routeId: route.id }}">
          <table>
            <tr>
              <td>
                <template v-if="route[language].Titel">
                  {{ route[language].Titel }}
                </template>
              </td>
            </tr>
          </table>
        </router-link>
      </li>
      <div style="clear: both" />
    </ul>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'RouteListe',
  props: {
    routen: Array,
  },
  computed: {
    language: function () {
      return this.$root.$i18n.locale
    },
  },
}
</script>

<style scoped lang="scss">
.routes a {
  display: block !important;
}
</style>
